import type { FetchResponse } from '@sydle/ui-api';
import { portalCustomAPI } from '.';
import type { CatalogNode } from '../models/CatalogNode';
import type { PortalLinkCardConfig } from '../models/portal/PortalLinkCardConfig';

export interface AvailableCatalogsInput {
  application: string;
  catalogs: string[];
  linkConfig?: PortalLinkCardConfig;
  params?: {
    pageIndex: number;
    pageSize: number;
    query: any;
    sort: any;
  };
  returnFields?: string[];
}

export interface AvailableCatalogsOutput {
  hits?: number;
  return?: CatalogNode[];
}

export function availablesCatalogs(input: AvailableCatalogsInput): Promise<FetchResponse<AvailableCatalogsOutput>> {
  return portalCustomAPI.fetch<AvailableCatalogsInput, AvailableCatalogsOutput>('availablesCatalogs', input);
}
